// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use environment variables for deployment flexibility
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://ateoqefwjeivvlnfpmon.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF0ZW9xZWZ3amVpdnZsbmZwbW9uIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU5MTYyNTEsImV4cCI6MjA3MTQ5MjI1MX0.fQvbV_PDXcF98Ldtg4leYXYkUnuJuTDOdjNdxXogfcU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});